import { render, staticRenderFns } from "./LeGamesTable.vue?vue&type=template&id=096f491a"
import script from "./LeGamesTable.vue?vue&type=script&lang=js"
export * from "./LeGamesTable.vue?vue&type=script&lang=js"
import style0 from "./LeGamesTable.vue?vue&type=style&index=0&id=096f491a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports